import { Input } from "antd";

const TextInput = ({
    id,
    name,
    label,
    defaultValue,
    onChange,
    placeholder,
    suffix,
    handleEnter,
    value,
}) => {
    return (
        <div>
            <label htmlFor={id}>{label}</label>
            <Input
                id={id}
                value={value}
                suffix={suffix}
                type="text"
                className="form-control border-DCDCDC text-input"
                placeholder={placeholder}
                defaultValue={defaultValue}
                onChange={onChange}
                onKeyDown={handleEnter && handleEnter("enter")}
                onBlur={handleEnter && handleEnter("blur")}
                style={{ height: "38px" }}
                name={name}
            />
        </div>
    );
};

export default TextInput;
